import { AllGamesRes } from "../types/basetype";
import { apiRequest } from "../utils/utils";

export class GamesApi {
    static async getAllGames(): Promise<AllGamesRes> {
        const r: any = await apiRequest("/games/all", "GET");
        return r.data as AllGamesRes;
    }
}